import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { renderIf, initializeTableColumns } from 'core/utils';
import { TableEmptyTemplate } from 'themes/components';
import { CustomActions, CommandCellData, OnSelectAllCheckboxHeader, CheckboxCellData } from 'core/stores';
import { localStorageHandler } from 'core/services';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import _ from 'lodash';

function BaasicTableTemplateKendo(props) {
	const {
		actions,
		showActions,
		showFiller,
		noDataItem,
		detailComponent,
		isModal,
		showImage,
		isSelectAllCheckboxSelected,
		onSelectAllHeaderClick,
		onCheckboxChange,
		t,
		groupedColumns,
		groupable,
		onGroupChange,
		group,
		onItemChange,
		cellRender,
		bulkPrintMode,
		...otherProps
	} = props;
	const onColumnResize = (resizeEvent, viewStore) => {
		if (resizeEvent) {
			_.forEach(resizeEvent.columns, userColumn => {
				_.forEach(viewStore.tableData.columns, column => {
					if (column.key === userColumn.field) {
						column.width = userColumn.width;
					}
					if (_.has(column, 'nestedColumns')) {
						_.forEach(column.nestedColumns, nestedColumn => {
							if (userColumn.title === nestedColumn.warehouseKey) {
								_.forEach(userColumn.children, children => {
									if (children.field === nestedColumn.key) {
										nestedColumn.width = children.width;
									}
								});
							}
						});
					}
				});
			});
			let columnsWidth = _.map(viewStore.tableData.columns, column => {
				let nestedColumns = [];
				if (_.has(column, 'nestedColumns')) {
					nestedColumns = _.forEach(column.nestedColumns, nestedColumn => {
						return { nestedColumn };
					});
					return { title: column.title, nestedColumns: nestedColumns };
				} else {
					return { key: column.key, width: column.width };
				}
			});
			// Column width persistance.
			localStorageHandler.set(viewStore.localStorageWidthKey, columnsWidth);
		}
	};

	return (
		<Grid
			{...otherProps}
			className={
				otherProps.data.length == 0
					? noDataItem
						? 'no-data--in-item'
						: isModal
						? 'no-data-modal'
						: 'no-data'
					: undefined
			}
			onColumnResize={event => onColumnResize(event, otherProps.viewStore)}
			data={group == null ? (otherProps.data ? otherProps.data.slice() : otherProps.data.slice()) : otherProps.data}
			expandField={'expanded'}
			detail={detailComponent || false}
			cellRender={cellRender}
			group={group}
			onItemChange={onItemChange}
		>
			<GridNoRecords>
				<TableEmptyTemplate showImage={showImage == undefined ? true : showImage} />
			</GridNoRecords>
			{otherProps.showSelectAllColumn && (
				<GridColumn
					key={'selectAllCheckbox'}
					headerCell={() => (
						<OnSelectAllCheckboxHeader
							onHeaderChange={onSelectAllHeaderClick}
							isSelectAllCheckboxSelected={isSelectAllCheckboxSelected}
						/>
					)}
					cell={props => <CheckboxCellData {...props} onClick={onCheckboxChange} />}
					field={'isChecked'}
					width={'55'}
					resizable={false}
					locked={true}
				/>
			)}
			{initializeTableColumns({ t, ...otherProps })}
			{renderIf(showFiller)(
				<GridColumn
					key={'gridColumnFiller'}
					field={''}
					headerClassName={'k-no-border k-custom-actions'}
					className={'k-no-border'}
					sortable={false}
				/>
			)}
			{renderIf(actions && showActions && !bulkPrintMode)(
				<GridColumn
					key={'gridColumnActions'}
					field={'actions'}
					title={t('ACTIONS')}
					width={150}
					sortable={false}
					headerClassName={'k-custom-actions'}
					locked={true}
					cell={props => <CustomActions {...props} viewStore={actions} t={t} />}
				/>
			)}
			{renderIf((otherProps.editField && otherProps.allowEdit) || otherProps.showCustomActions)(
				<GridColumn sortable={false} cell={props => <CommandCellData {...otherProps} {...props} t={t} />} width={200} />
			)}
		</Grid>
	);
}

export default defaultTemplate(BaasicTableTemplateKendo);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/BaasicTableTemplate.jsx